import { render, staticRenderFns } from "./TchekSummaryGallery.vue?vue&type=template&id=ca1facde"
import script from "./TchekSummaryGallery.vue?vue&type=script&lang=js"
export * from "./TchekSummaryGallery.vue?vue&type=script&lang=js"
import style0 from "./TchekSummaryGallery.vue?vue&type=style&index=0&id=ca1facde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports